import * as yup from "yup";

export type AuthFormValues = {
  email: string;
  password: string;
};

export const getAuthValidationSchema = (passwordRequired: boolean) =>
  yup.object({
    email: yup
      .string()
      .email("Не правильний формат електронної адреси")
      .required("Вкажіть свою електронну адресу"),
    password: passwordRequired
      ? yup
          .string()
          .required("Вкажіть пароль")
          .min(6, "Пароль має містити більше 6-ти символів")
      : yup.string().default(""),
  });
